export default "__VITE_ASSET__z$CB13fK__"